import { useContext } from "react";

import { AppContext } from "../contexts/app-context";

/** Create Hook to consumer Context */
export const useAppContext = () => {
	const result = useContext(AppContext);
	// By default an empty object is used, assume when no editor, no AppContextProvider available
	eXpress.utils.assert(
		result.editor,
		"useAppContext requires an <AppContextProvider> as parent.",
	);
	return result;
};
